export default "__VITE_ASSET__CToIe4Ur__"